Px.Editor.Header = class Header extends Px.Editor.BaseComponent {

  template() {
    const r = this.renderChild;
    const store = this.data.store;
    return Px.template`
      <header class="px-header">
        <div class="px-left-content">
          <a class="px-logo-link" href="${this.data.homepage_url}" data-onclick="goToHomepage">
            <img class="px-logo" src="${this.logoImagePath}" alt="" />
          </a>
        </div>

        <div class="px-center-content">
          ${Px.if(this.showSpinner, () => {
            return r(Px.Components.Spinner, 'spinner', {active: this.showSpinner});
          }).else(() => {
            return Px.template`
              <div class="px-project-info">
                <div class="px-product-name">
                  ${this.productName}
                </div>
              </div>
            `;
          })}
        </div>

        <div class="px-right-content">
          ${Px.if(this.inPreviewMode, () => {
            return Px.template`
              <button class="px-button px-large px-strong px-primary-color px-exit-button"
                      data-onclick="exitPreviewMode">
                ${Px.raw(Header.icons.preview)}
                ${Px.t('Close')}
                ${Px.raw(Px.Editor.Main.icons.cross)}
              </button>
            `;
          }).elseIf(store.ui.main_view === 'organize-pages', () => {
            return Px.template`
              <button class="px-button px-large px-strong px-primary-color px-exit-button"
                      data-onclick="exitOrganizePagesMode">
                ${Px.raw(Px.Editor.Main.icons.organize_pages)}
                ${Px.t('Close')}
                ${Px.raw(Px.Editor.Main.icons.cross)}
              </button>
            `;
          }).elseIf(store.cut_print_mode && store.main_view === 'edit-pages', () => {
            return Px.template`
              <button class="px-button px-small px-strong px-primary-color px-exit-button"
                      data-onclick="backToCutPrintSelection">
                ${Px.raw(Px.Editor.Main.icons.images)}
                ${Px.t('Close')}
                ${Px.raw(Px.Editor.Main.icons.cross)}
              </button>
            `;
          }).elseIf(store.ui.share_view, () => {
            if (this.showCopyButton) {
              return Px.template`
                <button data-onclick="copySharedProject" class="px-large px-strong px-secondary-color px-share-save">
                  ${Px.raw(this.data.save_icon)}
                  ${Px.t('Save copy')}
                </div>
              `;
            } else {
              return this.project_name_template();
            }
          }).else(() => {
            return Px.template`
              ${this.project_name_template()}
              <div class="px-icon-buttons">
                ${Px.if(this.showSaveButton, () => {
                  return Px.template`
                    <button class="px-button"
                            data-icon-id="save"
                            data-onclick="saveProjectModal"
                            data-px-tooltip="${Px.t('Save/Exit')}"
                            data-px-tooltip-offset="0">
                        ${Px.raw(Header.icons.save)}
                    </button>
                  `;
                })}
                ${Px.if(this.showPreviewButton, () => {
                  return Px.template`
                    <button class="px-button"
                            data-icon-id="preview"
                            data-onclick="togglePreviewMode"
                            data-px-tooltip="${Px.t('Preview')}"
                            data-px-tooltip-offset="0">
                        ${Px.raw(Header.icons.preview)}
                    </button>
                  `;
                })}
                ${Px.if(this.showHelpButton, () => {
                  return Px.template`
                    <button class="px-button"
                            data-icon-id="help"
                            data-onclick="showHelp"
                            data-px-tooltip="${Px.t('Help')}"
                            data-px-tooltip-offset="0">
                        ${Px.raw(Header.icons.help)}
                    </button>
                  `;
                })}
              </div>
              ${Px.if(this.showCartButton, () => {
                const label = Px.urlQuery().cart === 't' ? Px.t('Save to cart') : Px.t('Add to cart');
                return Px.template`
                  <button class="px-cart-button px-button"
                          ${this.isCartButtonDisabled ? 'disabled' : ''}
                          data-onclick="addToCart"
                          ${this.priceText ? Px.template`data-px-tooltip="${label}"` : ''}>
                      ${Px.raw(Header.icons.cart)}
                      <span class="px-text">
                        ${Px.if(this.priceText, () => {
                          return Px.raw(this.priceText);
                        }).else(() => {
                          return label;
                        })}
                      </span>
                      ${Px.raw(Header.icons.cart_arrow)}
                  </button>
                `;
              })}
              ${Px.if(this.showExitButton, () => {
                return Px.template`
                  <button class="px-button px-editor-exit-button"
                          data-icon-id="exit"
                          data-onclick="exitEditor"
                          data-px-tooltip="${Px.t('Exit')}"
                          data-px-tooltip-offset="0">
                      ${Px.raw(Header.icons.exit)}
                  </button>
                `;
              })}
            `;
          })}
        </div>

        <div class="px-notifications">
          ${this.notifications.map(notification => {
            return r(Px.Editor.Notification, `notification-${notification.id}`, {notification: notification})
          })}
        </div>
      </header>
    `;
  }

  project_name_template() {
    const store = this.data.store;
    const disabled = store.ui.preview_mode || store.resource_type !== 'book';
    return Px.template`
      <div class="px-project-name-wrapper">
        <input class="px-project-name"
              data-onchange="saveName"
              data-onmouseup="selectIfDefault"
              data-onfocusin="selectIfDefault"
              data-onfocusout="resetNameIfEmpty"
              value="${this.inPreviewMode ? Px.t('Preview') : store.project.name}"
              ${disabled ? 'disabled' : Px.template`data-px-tooltip="${Px.t('Rename project')}"`}
        />
        ${Px.if(store.project.name === Px.config.default_project_name, () => {
          return Px.template`
            <div class="px-unedited-overlay">
              <svg><circle fill="currentColor" cx="3" cy="3" r="3"/></svg>
              <span>${store.project.name}</span>
            </div>
          `;
        })}
      </div>
    `;
  }

  get dataProperties() {
    return {
      store: {required: true},
      homepage_url: {required: true},
      save_icon: {required: true},
      cart_callback: {required: true},
      save_callback: {required: true},
      exit_callback: {required: true},
      preview_mode_callback: {required: true},
      help_callback: {required: true}
    };
  }

  static get computedProperties() {
    return {
      showSpinner: function() {
        const store = this.data.store;
        return store.loading || store.galleries.project.import_in_progress;
      },
      notifications: function() {
        return this.data.store.notifications.notifications;
      },
      logoImagePath: function() {
        const default_logo_path = '/site_images/pixfizz-logo.svg';
        if (this.data.store.resource_type !== 'book') {
          return default_logo_path;
        }
        return Px.config.logo_image_path || default_logo_path;
      },
      showCartButton: function() {
        const store = this.data.store;
        return store.resource_type === 'book' && !store.ui.share_view;
      },
      isCartButtonDisabled: function() {
        const store = this.data.store;
        return store.cut_print_mode && store.total_cut_print_quantity === 0;
      },
      showSaveButton: function() {
        const store = this.data.store;
        if (store.external_integration.showSaveButton) {
          return store.external_integration.showSaveButton(store);
        }
        const url_query = Px.urlQuery();
        return !(url_query.cart === 't' || url_query.parent_orderline);
      },
      showPreviewButton: function() {
        const store = this.data.store;
        return store.theme.loaded && !store.cut_print_mode;
      },
      showHelpButton: function() {
        return Boolean((Px.config.help_url || '').trim());
      },
      showExitButton: function() {
        const store = this.data.store;
        if (store.external_integration.showExitButton) {
          return store.external_integration.showExitButton(store);
        }
        return true;
      },
      showCopyButton: function() {
        return this.data.store.ui.share_view && Px.config.copy_shared_projects;
      },
      inPreviewMode: function() {
        return this.data.store.ui.preview_mode && !this.data.store.ui.share_view;
      },
      productName: function() {
        const store = this.data.store;
        if (store.resource_type === 'book') {
          return store.project.product_name;
        } else {
          return `Design: ${store.theme.name}`;
        }
      },
      priceText: function() {
        const store = this.data.store;
        if (!Px.config.display_price || store.price === null) {
          return '';
        }
        const formatted_price = Px.Util.formatCurrency(store.price, Px.config.currency_format);
        const quantity = store.quantity;
        if (quantity > 1 && !store.cut_print_mode) {
          return Px.t('{{price}} each').replace('{{price}}', formatted_price);
        } else {
          return formatted_price;
        }
      }
    };
  }

  // --------------
  // Event handlers
  // --------------

  saveName(evt) {
    const new_name = evt.target.value.trim();
    if (new_name) {
      this.data.store.project.updateName(new_name);
      evt.target.blur();
    }
  }

  addToCart(evt) {
    this.data.cart_callback();
  }

  saveProjectModal(evt) {
    this.data.save_callback();
  }

  togglePreviewMode(evt) {
    this.data.preview_mode_callback();
  }

  showHelp(evt) {
    this.data.help_callback();
  }

  goToHomepage(evt) {
    const main_store = this.data.store;
    if (main_store.external_integration.goToUrl) {
      evt.preventDefault();
      main_store.external_integration.goToUrl(main_store, this.data.homepage_url);
    } else {
      // Do nothing, link will take us to the homepage by default.
    }
  }

  exitEditor(evt) {
    this.data.exit_callback();
  }

  // Selects the project text name (if it equals the default 'My Project' name).
  // This needs to be invoked both from focusin as well as mouseup handlers, otherwise the mouseup
  // event deselects the text in Safari.
  selectIfDefault(evt) {
    const value = evt.target.value;
    if (value === Px.config.default_project_name) {
      evt.preventDefault();
      evt.target.setSelectionRange(0, value.length + 1);
    }
  }

  resetNameIfEmpty(evt) {
    if (!evt.target.value.trim()) {
      evt.target.value = this.data.store.project.name;
    }
  }

  copySharedProject(evt) {
    let promise = this.data.store.project.copySharedProject();
    promise.then(() => {
      window.location = editor.saveTarget();
    }).catch((e) => alert("Failed to copy project"));
  }

  exitPreviewMode(evt) {
    this.data.store.ui.togglePreviewMode();
  }

  exitOrganizePagesMode(evt) {
    this.data.store.ui.setMainView('edit-pages');
  }

  backToCutPrintSelection(evt) {
    this.data.store.selectSet(null);
  }

};

Px.Editor.Header.icons = {
  cart: '<svg width="26" height="26" viewBox="0 0 26 26" fill="none"><path d="M9.75001 21.667C9.75001 22.2416 9.52174 22.7927 9.11541 23.1991C8.70908 23.6054 8.15798 23.8337 7.58334 23.8337C7.00871 23.8337 6.45761 23.6054 6.05128 23.1991C5.64495 22.7927 5.41668 22.2416 5.41668 21.667C5.41668 21.0924 5.64495 20.5413 6.05128 20.1349C6.45761 19.7286 7.00871 19.5003 7.58334 19.5003C8.15798 19.5003 8.70908 19.7286 9.11541 20.1349C9.52174 20.5413 9.75001 21.0924 9.75001 21.667ZM18.4167 19.5003C17.842 19.5003 17.2909 19.7286 16.8846 20.1349C16.4783 20.5413 16.25 21.0924 16.25 21.667C16.25 22.2416 16.4783 22.7927 16.8846 23.1991C17.2909 23.6054 17.842 23.8337 18.4167 23.8337C18.9913 23.8337 19.5424 23.6054 19.9487 23.1991C20.3551 22.7927 20.5833 22.2416 20.5833 21.667C20.5833 21.0924 20.3551 20.5413 19.9487 20.1349C19.5424 19.7286 18.9913 19.5003 18.4167 19.5003ZM7.80001 15.8495C7.78918 15.8928 7.78918 15.9362 7.80001 15.9795C7.80001 16.0513 7.82854 16.1202 7.87934 16.171C7.93013 16.2218 7.99901 16.2503 8.07084 16.2503H20.5833V18.417H7.58334C7.00871 18.417 6.45761 18.1887 6.05128 17.7824C5.64495 17.3761 5.41668 16.825 5.41668 16.2503C5.41668 15.8712 5.49251 15.5028 5.67668 15.167L7.15001 12.5562L3.25001 4.33366H1.08334V2.16699H4.62584L5.64418 4.33366H21.6667C21.954 4.33366 22.2295 4.4478 22.4327 4.65096C22.6359 4.85412 22.75 5.12967 22.75 5.41699C22.75 5.60116 22.6958 5.78533 22.62 5.95866L18.7417 13.0003C18.3517 13.672 17.6258 14.0837 16.8458 14.0837H8.77501L7.80001 15.8495ZM9.75001 10.292H14.0833V12.4587L17.3333 9.20866L14.0833 5.95866V8.12533H9.75001V10.292Z" fill="currentColor"/></svg>',
  cart_arrow: '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M6.65749 2.91585C6.54847 3.02748 6.48743 3.17732 6.48743 3.33335C6.48743 3.48939 6.54847 3.63923 6.65749 3.75085L12.7487 9.99961L6.65749 16.2471C6.54847 16.3587 6.48743 16.5086 6.48743 16.6646C6.48743 16.8206 6.54847 16.9705 6.65749 17.0821C6.71049 17.1365 6.77385 17.1798 6.84384 17.2093C6.91383 17.2389 6.98903 17.2541 7.06499 17.2541C7.14096 17.2541 7.21616 17.2389 7.28615 17.2093C7.35614 17.1798 7.4195 17.1365 7.47249 17.0821L13.95 10.4359C14.0638 10.3191 14.1274 10.1626 14.1274 9.99961C14.1274 9.83661 14.0638 9.68007 13.95 9.56335L7.47249 2.9171C7.4195 2.86268 7.35614 2.81941 7.28615 2.78988C7.21616 2.76034 7.14096 2.74512 7.06499 2.74512C6.98903 2.74512 6.91383 2.76034 6.84384 2.78988C6.77385 2.81941 6.71049 2.86268 6.65749 2.9171V2.91585Z" fill="currentColor"/></svg>',
  save: '<svg width="20" height="22" viewBox="0 0 20 22"><g clip-path="url(#clip0_613_779)"><path d="M18.6459 5.5834L15.0416 1.9791C14.6548 1.5923 14.1302 1.375 13.5832 1.375H2.0625C0.923398 1.375 0 2.2984 0 3.4375V18.5625C0 19.7016 0.923398 20.625 2.0625 20.625H17.1875C18.3266 20.625 19.25 19.7016 19.25 18.5625V7.0418C19.25 6.4948 19.0327 5.97019 18.6459 5.5834ZM11.6875 3.4375V6.875H6.1875V3.4375H11.6875ZM16.9297 18.5625H2.32031C2.25194 18.5625 2.18636 18.5353 2.13801 18.487C2.08966 18.4386 2.0625 18.3731 2.0625 18.3047V3.69531C2.0625 3.62694 2.08966 3.56136 2.13801 3.51301C2.18636 3.46466 2.25194 3.4375 2.32031 3.4375H4.125V7.90625C4.125 8.4758 4.5867 8.9375 5.15625 8.9375H12.7188C13.2883 8.9375 13.75 8.4758 13.75 7.90625V3.6043L17.112 6.96631C17.1359 6.99025 17.1549 7.01868 17.1679 7.04996C17.1808 7.08124 17.1875 7.11477 17.1875 7.14862V18.3047C17.1875 18.3731 17.1603 18.4386 17.112 18.487C17.0636 18.5353 16.9981 18.5625 16.9297 18.5625ZM9.625 9.96875C7.54003 9.96875 5.84375 11.665 5.84375 13.75C5.84375 15.835 7.54003 17.5312 9.625 17.5312C11.71 17.5312 13.4062 15.835 13.4062 13.75C13.4062 11.665 11.71 9.96875 9.625 9.96875ZM9.625 15.4688C8.67728 15.4688 7.90625 14.6977 7.90625 13.75C7.90625 12.8023 8.67728 12.0312 9.625 12.0312C10.5727 12.0312 11.3438 12.8023 11.3438 13.75C11.3438 14.6977 10.5727 15.4688 9.625 15.4688Z" fill="currentColor"/></g><defs><clipPath id="clip0_613_779"><rect width="19.25" height="22" fill="white"/></clipPath></defs></svg>',
  preview: '<svg width="22" height="22" viewBox="0 0 22 22"><path d="M10.8333 20C15.804 20 19.8333 15.9707 19.8333 11C19.8333 6.0293 15.804 2 10.8333 2C5.86255 2 1.83325 6.0293 1.83325 11C1.83325 15.9707 5.86255 20 10.8333 20Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/><path d="M9.0332 11.0024V7.88477L11.7332 9.44357L14.4332 11.0024L11.7332 12.5612L9.0332 14.12V11.0024Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/></svg>',
  help: '<svg width="22" height="22" viewBox="0 0 22 22" fill="none"><path d="M11 3.03833C8.88836 3.03833 6.86322 3.87717 5.37007 5.37032C3.87692 6.86346 3.03808 8.8886 3.03808 11.0002C3.03808 13.1119 3.87692 15.137 5.37007 16.6301C6.86322 18.1233 8.88836 18.9621 11 18.9621C13.1116 18.9621 15.1368 18.1233 16.6299 16.6301C18.1231 15.137 18.9619 13.1119 18.9619 11.0002C18.9619 8.8886 18.1231 6.86346 16.6299 5.37032C15.1368 3.87717 13.1116 3.03833 11 3.03833ZM1.04761 11.0002C1.04761 5.50353 5.50329 1.04785 11 1.04785C16.4967 1.04785 20.9524 5.50353 20.9524 11.0002C20.9524 16.4969 16.4967 20.9526 11 20.9526C5.50329 20.9526 1.04761 16.4969 1.04761 11.0002Z" fill="currentColor"/><path d="M10.9999 12.9906C10.736 12.9906 10.4828 12.8857 10.2962 12.6991C10.1096 12.5125 10.0047 12.2593 10.0047 11.9954V11.0001C10.0047 10.7362 10.1096 10.483 10.2962 10.2964C10.4828 10.1097 10.736 10.0049 10.9999 10.0049C11.2639 10.0049 11.517 10.1097 11.7037 10.2964C11.8903 10.483 11.9952 10.7362 11.9952 11.0001V11.9954C11.9952 12.2593 11.8903 12.5125 11.7037 12.6991C11.517 12.8857 11.2639 12.9906 10.9999 12.9906ZM9.50708 15.4787C9.50708 15.0828 9.66436 14.703 9.94433 14.4231C10.2243 14.1431 10.604 13.9858 10.9999 13.9858C11.3959 13.9858 11.7756 14.1431 12.0555 14.4231C12.3355 14.703 12.4928 15.0828 12.4928 15.4787C12.4928 15.8746 12.3355 16.2543 12.0555 16.5343C11.7756 16.8143 11.3959 16.9715 10.9999 16.9715C10.604 16.9715 10.2243 16.8143 9.94433 16.5343C9.66436 16.2543 9.50708 15.8746 9.50708 15.4787Z" fill="currentColor"/><path d="M11.388 6.83092C10.4356 6.78613 9.63642 7.31858 9.49311 8.17747C9.44298 8.43133 9.29595 8.65569 9.0832 8.80297C8.87044 8.95025 8.60869 9.00888 8.35343 8.96642C8.09818 8.92397 7.8695 8.78377 7.71587 8.57554C7.56224 8.36732 7.49576 8.10746 7.5305 7.85104C7.88481 5.72521 9.82253 4.76381 11.4826 4.84343C12.3325 4.88324 13.2073 5.18878 13.8801 5.81777C14.5698 6.46168 14.9809 7.38527 14.9809 8.51188C14.9809 9.79673 14.4753 10.7502 13.6044 11.3304C12.8053 11.8628 11.825 11.9952 10.9999 11.9952C10.7359 11.9952 10.4828 11.8904 10.2962 11.7037C10.1095 11.5171 10.0047 11.2639 10.0047 11C10.0047 10.736 10.1095 10.4829 10.2962 10.2962C10.4828 10.1096 10.7359 10.0047 10.9999 10.0047C11.6667 10.0047 12.1803 9.88829 12.5007 9.67431C12.7495 9.50811 12.9904 9.2165 12.9904 8.51188C12.9904 7.89682 12.7794 7.51365 12.5206 7.27181C12.2449 7.01404 11.8439 6.85381 11.388 6.83092Z" fill="currentColor"/></svg>',
  exit: '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0.579987 0.580719C0.790925 0.370043 1.07686 0.251709 1.37499 0.251709C1.67311 0.251709 1.95905 0.370043 2.16999 0.580719L6.99999 5.41072L11.83 0.580719C11.933 0.470189 12.0572 0.381535 12.1952 0.320047C12.3332 0.25856 12.4821 0.225497 12.6332 0.222831C12.7843 0.220166 12.9343 0.247953 13.0744 0.304535C13.2145 0.361116 13.3417 0.445333 13.4485 0.552161C13.5554 0.658989 13.6396 0.78624 13.6962 0.926323C13.7528 1.0664 13.7805 1.21645 13.7779 1.3675C13.7752 1.51856 13.7421 1.66753 13.6807 1.80553C13.6192 1.94352 13.5305 2.06773 13.42 2.17072L8.58999 7.00072L13.42 11.8307C13.5305 11.9337 13.6192 12.0579 13.6807 12.1959C13.7421 12.3339 13.7752 12.4829 13.7779 12.6339C13.7805 12.785 13.7528 12.935 13.6962 13.0751C13.6396 13.2152 13.5554 13.3424 13.4485 13.4493C13.3417 13.5561 13.2145 13.6403 13.0744 13.6969C12.9343 13.7535 12.7843 13.7813 12.6332 13.7786C12.4821 13.7759 12.3332 13.7429 12.1952 13.6814C12.0572 13.6199 11.933 13.5312 11.83 13.4207L6.99999 8.59072L2.16999 13.4207C1.95672 13.6194 1.67465 13.7276 1.3832 13.7225C1.09175 13.7173 0.813674 13.5993 0.607554 13.3932C0.401435 13.187 0.283367 12.909 0.278224 12.6175C0.273082 12.326 0.381267 12.044 0.579987 11.8307L5.40999 7.00072L0.579987 2.17072C0.369311 1.95978 0.250977 1.67384 0.250977 1.37572C0.250977 1.07759 0.369311 0.791657 0.579987 0.580719Z" fill="currentColor"/></svg>'
};
